import { AcessoCbo } from 'graphql/types.generated'
import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboPreNatal = [AcessoCbo.MEDICO, AcessoCbo.ENFERMEIRO]

export const grupoCboAcompanhamentoPreNatal = [...NIVEL_SUPERIOR, ...NIVEL_TECNICO]
